import type { ReactNode } from 'react';
import { Link } from '@ksyos/design-system';

interface IExternalLinkProps {
    children?: ReactNode;
    href: string;
}

export function ExternalLink(props: IExternalLinkProps) {
    return (
        <Link
            color="secondary"
            fontWeight="normal"
            href={props.href}
            openInNewTab
            variant="externalLink"
        >
            {props.children}
        </Link>
    );
}
